<div class="invoice-transmission-history-dialog">
	<div class="dialog-header">
		<h1 mat-dialog-title>{{ data.title }}</h1>
		<button mat-icon-button type="button" (click)="onClose()" class="close-button" aria-label="Close">
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<div mat-dialog-content>
		<div class="example-header">
			<mat-form-field class="filter-field">
				<input
					matInput
					(keyup)="applyFilter($event.target.value)"
					placeholder="Filter"
					autocomplete="off"
					[(ngModel)]="filter"
				/>
				<button
					mat-button
					*ngIf="filter !== ''"
					matSuffix
					mat-icon-button
					type="button"
					aria-label="Clear"
					(click)="clearFilters()"
				>
					<mat-icon>close</mat-icon>
				</button>
			</mat-form-field>
		</div>

		<div class="table-container" *ngIf="data.rows && data.rows.length > 0">
			<mat-table class="compact" [dataSource]="dataSource" matSort>
				<ng-container matColumnDef="transmissionDate">
					<mat-header-cell *matHeaderCellDef mat-sort-header class="align-left"> DATE </mat-header-cell>
					<mat-cell *matCellDef="let element" class="align-left">
						{{ element.transmissionDate | date : 'MM/dd/yyyy HH:mm:ss' }}
					</mat-cell>
				</ng-container>
				<ng-container matColumnDef="transmissionType">
					<mat-header-cell *matHeaderCellDef mat-sort-header class="align-left"> TYPE </mat-header-cell>
					<mat-cell *matCellDef="let element" class="align-left">{{ element.transmissionType }}</mat-cell>
				</ng-container>
				<ng-container matColumnDef="provider">
					<mat-header-cell *matHeaderCellDef mat-sort-header class="align-left"> PROVIDER </mat-header-cell>
					<mat-cell *matCellDef="let element" class="align-left">{{ element.provider }}</mat-cell>
				</ng-container>
				<ng-container matColumnDef="status">
					<mat-header-cell *matHeaderCellDef mat-sort-header class="align-left"> STATUS </mat-header-cell>
					<mat-cell *matCellDef="let element" class="align-left">
						<span class="status-badge" [ngClass]="getStatusClass(element.status)">
							{{ element.status }}
						</span>
					</mat-cell>
				</ng-container>
				<ng-container matColumnDef="userName">
					<mat-header-cell *matHeaderCellDef mat-sort-header class="align-left"> USER </mat-header-cell>
					<mat-cell *matCellDef="let element" class="align-left">{{ element.userName }}</mat-cell>
				</ng-container>
				<ng-container matColumnDef="invoiceNumber">
					<mat-header-cell *matHeaderCellDef mat-sort-header class="align-left"> INVOICE # </mat-header-cell>
					<mat-cell *matCellDef="let element" class="align-left">{{ element.invoiceNumber }}</mat-cell>
				</ng-container>
				<ng-container matColumnDef="description">
					<mat-header-cell *matHeaderCellDef class="align-center description-column"> </mat-header-cell>
					<mat-cell *matCellDef="let element" class="align-center description-column">
						<a
							href="javascript:void(0)"
							(click)="showDescription(element)"
							class="actionButton"
							matTooltip="Description"
							aria-label="View description"
						>
							<mat-icon>visibility</mat-icon>
						</a>
					</mat-cell>
				</ng-container>
				<mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
				<mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
			</mat-table>

			<div class="paginator-container">
				<mat-paginator [hidePageSize]="true" [pageSize]="10" showFirstLastButtons></mat-paginator>
			</div>
		</div>

		<div class="no-records" *ngIf="!data.rows || data.rows.length === 0">
			<p>No transmission history found.</p>
		</div>
	</div>

	<div mat-dialog-actions class="dialog-actions">
		<button mat-raised-button color="btnprimary" type="button" (click)="onClose()">Close</button>
	</div>
</div>
